const studsidebaritems = [
    {
        display_name: 'Student Dashboard',
        cName: 'side-text-title',
        route: './dashboard',
    },
    {
        display_name: 'All My Projects',
        route: './allownedprojects',
        cName: 'side-text',
    },
    {
        display_name: 'Invitations',
        route: './invitations',
        cName: 'side-text',
    },
    {
        display_name: 'Bookmarked Projects',
        route: './bookmarkedprojects',
        cName: 'side-text',
    },
    {
        display_name: 'Bookmarked Members',
        route: './bookmarkedmembers',
        cName: 'side-text',
    },
    {
        display_name: 'Invited Members',
        route: './invitedmembers',
        cName: 'side-text',
    },
]

export default studsidebaritems
